export default __webpack_public_path__ + "static/media/live-tests.41cb7b56.png";